export default "__VITE_ASSET__C2GQ05Dt__"